var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5bd64657be7efbc4e2edfb504353cb5d14814f3e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dashboard-ui@emptor"]={id:"5bd64657be7efbc4e2edfb504353cb5d14814f3e"};
      